export const septemberAbbreviatedLowercase = "Sqa";
export default {septemberAbbreviatedLowercase};